// 初始化极验
/**
 * 极验参考文档：https://docs.geetest.com/sensebot/apirefer/api/web#product
 * @param {*} captchaId 极验需要的id
 * @param {*} product 极验的弹出框类型，可选值为bind（隐藏按钮类型）(目前我们业务场景都是用bind)、popup（弹出式）、float（浮动式）、custom（与popup类似，但是可以自定义弹出区域）
 * @param {*} language 站点语言
 * @param {*} successCallBackFn 用户验证成功之后回调的方法，这个回调方法回传极验验证的参数可用于后续的业务接口调用
 */
export const useInitGeetest = ({captchaId, product, language, successCallBackFn} = {}) => {
  console.log(language,'language666');
  
  const validateParams = {};
  window.initGeetest4 &&
    window.initGeetest4(
      {
        captchaId,
        product,
        width: "100%",
        language, // 语言
        hideSuccess: true,
        onError: (error) => {
          console.error("极验初始化失败:", error);
        },
      },
      (captchaObj) => {
        window.captchaObj = captchaObj;
        captchaObj.onSuccess(async () => {
          validateParams.captcha_id =
          window.captchaObj.getValidate().captcha_id;
          validateParams.captcha_output =
          window.captchaObj.getValidate().captcha_output;
          validateParams.gen_time = window.captchaObj.getValidate().gen_time;
          validateParams.lot_number =
          window.captchaObj.getValidate().lot_number;
          validateParams.pass_token =
          window.captchaObj.getValidate().pass_token;
          successCallBackFn(captchaObj, validateParams);
        });
      }
    );
};

export const useGeetestLanguage = (lan) => {
  const language = lan || document.documentElement?.getAttribute('lang') || 'en'; // 获取html的lang值
  const list = {
      zh: 'zho', // 简体中文
      en: 'eng', // 英文
      tw: 'zho-tw', // 台湾
      hk: 'zho-hk', // 香港
      udm: 'udm', // 维吾尔语
      jp: 'jpn', // 日文
      ind: 'ind', // 印尼
      kor: 'kor', // 韩语
      rus: 'rus', // 俄语
      ara: 'ara', // 阿拉伯语
      span: 'spa', // 西班牙语
      br: 'pon', // 巴西葡语
      por: 'por', // 欧洲葡语
      fr: 'fr', // 法语（目前语言选择是fr没有fra，保留fra的避免对其他模块有影响）
      fra: 'fra', // 法语
      de: 'deu', // 德语
      th: 'tha', // 泰国
      vn: 'vie', // 越南
      ms: 'msa', // 马来西亚
      es: 'spa', // 西班牙语 (墨西哥的)
      ar: 'ar', // 阿拉伯语(语言会镜像翻转)
      he: 'haw-he', // 希伯来语（现代代码)
      iw: 'haw-iw', // 希伯来语（旧代码）
  };
  if (list[`${language}`]) {
    return list[`${language}`];
  } else {
    const sort_lan = language.split('-')[0];
    return list[`${sort_lan}`];
  }
  
};